import React, { useEffect, useState } from "react";

import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationOptions } from "@react-navigation/native-stack";
import { ScrollView } from "react-native";
import { FloatingButton, Header, InfoBanner, KeyboardAwareView } from "ui";

import CombinationInfo from "./CombinationInfo";
import CombinationInventoryForm from "./CombinationInventoryForm";
import useProductFormFormik from "../../hooks/useProductFormFormik";
import { StackScreenProps, productFormRoutes } from "../../navigation/types";
import { Combination } from "../../types";

type NavProps = StackScreenProps<typeof productFormRoutes.combinationInventory>;
export default function CombinationInventoryScreen({ navigation }: NavProps) {
  const { setCombinationInventory, setStatus, status } = useProductFormFormik();

  const { variantOptions, inventory } =
    status.selectedCombination as Combination;

  const options = variantOptions.map((vo) => vo.option);

  // store inventory in local state so we don't override form values unless saving
  const [currentInventory, setCurrentInventory] = useState(inventory);

  useEffect(() => {
    // track if combination is dirty in formik to check for unsaved changes
    setStatus({
      ...status,
      combinationIsDirty: currentInventory !== inventory,
    });
  }, [currentInventory]);

  const setEnabled = (enabled: boolean) => {
    setCurrentInventory((prev) => ({ ...prev, enabled }));
  };

  const setQuantity = (quantity: number) => {
    setCurrentInventory((prev) => ({ ...prev, quantity }));
  };

  const onButtonPress = () => {
    setCombinationInventory(status.selectedCombination, currentInventory);
    navigation.goBack();
  };

  return (
    <KeyboardAwareView>
      <ScrollView>
        <InfoBanner text="Maneja el inventario de la combiación indicada debajo." />
        <CombinationInfo options={options} inventory={currentInventory} />
        <CombinationInventoryForm
          enabled={currentInventory.enabled}
          quantity={currentInventory.quantity}
          setEnabled={setEnabled}
          setQuantity={setQuantity}
        />
      </ScrollView>
      <FloatingButton text="Guardar" onPress={onButtonPress} />
    </KeyboardAwareView>
  );
}

export const combinationInventoryScreenOptions: NativeStackNavigationOptions = {
  header: () => <CombinationInventoryHeader />,
};

function CombinationInventoryHeader() {
  const { status } = useProductFormFormik();
  const { goBack } = useNavigation<NavProps["navigation"]>();

  return (
    <Header
      title="Inventario por variantes"
      onBackPress={status?.combinationIsDirty ? goBack : undefined}
    />
  );
}
